import React from "react";
import TextAreaField from "../../forms/textarea-field";
const StoreRemarksTab = ({ disabled = false }) => {
  return (
    <div className="w-full 2xl:w-[40%] xl:w-[50%] lg:w-[60%] px-5 xl:px-10 mt-5">
      <TextAreaField
        isDisabled={disabled}
        label="Remarks"
        placeholder="Enter your remarks here..."
        name="tab_remarks"
        id={"tab_remarks"}
        // isRequired={false}
        labelWidth="7rem"
        feildHeight="7rem"
      />
    </div>
  );
};

export default StoreRemarksTab;
